export default __webpack_public_path__ + "static/media/icons8-nodejs.656e25dd.svg";